import { render, staticRenderFns } from "./BranchCategoryEditor.vue?vue&type=template&id=93d65f88&scoped=true"
import script from "./BranchCategoryEditor.vue?vue&type=script&lang=ts"
export * from "./BranchCategoryEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d65f88",
  null
  
)

export default component.exports